/* eslint-disable react/no-unstable-nested-components */
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import * as Sentry from '@sentry/react';
import Box from '@/Atoms/Box';
import {Chess} from 'chess.js';
import {useNavigation, useRoute, useLinkTo} from '@react-navigation/native';
import {Video, ResizeMode} from 'expo-av';
import {DrawerActions} from '@react-navigation/native';
import ChessboardComponent from 'chessboard-package';
import {styles, filterStyles, infoStyles} from '../Puzzles/styles';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import useAnimation from '@/Hooks/useAnimation';
import Animated from 'react-native-reanimated';
import Ionicons from 'react-native-vector-icons/Ionicons';
import CCText from '@/Atoms/CCText';
import {Table, Row} from 'react-native-table-component';

import {
  useBooksApi,
  useBookOrderApi,
  useBookOrderStatusApi,
  useVideoCoursesApi,
  useVideoCourseByIdApi,
} from '@/Hooks/BooksApi/useBooksApi';
import squares from '../../Assets/Images/Svgs/squares.svg';
import challengeIcon from '../../Assets/Images/Svgs/challengehover.svg';
import logoIcon from '../../Assets/Images/Svgs/logoicon.svg';
import caissaAvatar from '../../Assets/Images/Svgs/caissaAvatar.svg';
import chevronDoubleDown from '../../Assets/Images/Svgs/chevronDoubleDown.svg';
import chevronDoubleUp from '../../Assets/Images/Svgs/chevronDoubleUp.svg';
import useBookPuzzleSolveApi from '@/Hooks/BooksApi/useBookPuzzleSolveApi';
import CCSelect from '@/Atoms/CCSelect';
import {
  View,
  Image,
  Platform,
  ScrollView,
  Pressable,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import wrongSound from '../../Assets/Sounds/wrong.mp3';
import bookIcon from '../../Assets/Images/Svgs/new_book_icon.svg';
import chapterIcon from '../../Assets/Images/png/chapter.png';
import search from '../../Assets/Images/png/search.png';
import upload from '../../Assets/Images/png/upload.png';
import discover from '../../Assets/Images/png/book-closed.png';
import emptyBook from '../../Assets/Images/png/empty_book.png';
import emptyResult from '../../Assets/Images/png/empty_result.png';
import congrats from '../../Assets/Images/Svgs/congrats.svg';
import useSound from 'use-sound';
import {FontSizes, vs, WINDOW_WIDTH} from '@/Utils/Dimensions';
import CCButton from '@/Atoms/CCButton';
import AntDesign from 'react-native-vector-icons/AntDesign';
// import DocumentPickerfrom 'react-native-document-picker';
import CCTabs from '@/Atoms/CCTabs';
import BookCard from './components/BookCard';
import VideoCard from './components/VideoCard';
import CCTextInput from '@/Atoms/CCTextInput';
import Spacer from '@/Atoms/Spacer';
import SlideModal from '@/Atoms/SlideModal';
import UploadBook from './components/UploadBook';
import ProgressBar from '@/Atoms/ProgressBar';
import Divider from '@/Atoms/Divider/Divider';
import Empty from '@/Atoms/Empty';
import ccleagueBanner from '../../Assets/Images/Svgs/ccleague.svg';
import {
  debounce,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  handleLogout,
  formatDateToDDMMYYYY,
  openPopup,
} from '@/Utils/CommonUtils';
import {Linking} from 'react-native';
import {ScreenName} from '@/navigators/StackConstants';
import Loader from '@/Atoms/CCLoader/CCLoader';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Assignment from './components/Assignment';
import ChapterList from './components/ChaptersList';
import VideoPlayerWeb from '@/Atoms/VideoPlayerWeb';
import Leaderboard from './components/Leaderboard';
import UploadVideo from './components/UploadVideo';
import ChessboardWithArrow from '@/Components/ChessboardWithArrow';
import CCLeague from './components/CCLeague';
import Meetings from './components/Meetings';
import MentorCalls from './components/MentorCalls';
import SubscriptionTab from './components/Subscription';
import {PopUp} from '../Visualisation/components/LevelModal';
import Pagination from '../Games/Pagination';
import {useLoginState} from '@/Hooks/LoginApi/loginApi';
import TaskList from './components/TaskList';
import PuzzleAvatar, {AvatarStatus} from './components/PuzzleAvatar';
import useGetSubscriptionDetailsApi from '@/Hooks/SubscriptionDetails/useSubscriptionDetails';
import useCsocProfileNudge from './useCsocProfileNudge';
import CsocProfileGate from './CsocProfileGate';
import useTopBanner from './hooks/useTopBanner';
import TopBannerRenderer from './components/TopBannerRenderer';

const ChessBoardLoader = ({children, isLoading = false}) => {
  const [opacityAnimStyle, startOpacityAnim] = useAnimation({
    prop: 'opacity',
    start: 0,
    end: 0.8,
    repeat: true,
  });

  const [isLoadingDelayed, setIsLoadingDelayed] = useState(isLoading);
  // const isLoadingDelayed = isLoading;
  // console.log('loader', isLoading, isLoadingDelayed);
  useEffect(() => {
    // reset isLoadingDelayed after reloading puzzle
    if (isLoading && !isLoadingDelayed) {
      setIsLoadingDelayed(true);
    }

    if (isLoading) {
      startOpacityAnim();
    } else {
      // chessboard has loaded, wait for pieces to finish flying around
      const id = setTimeout(() => {
        setIsLoadingDelayed(false);
        // setIsLoadingDelayed = false;
      }, 600);
      return () => {
        clearInterval(id);
      };
    }
  }, [isLoading]);

  return (
    <View>
      {isLoadingDelayed && (
        <>
          <Animated.View
            style={[
              {
                zIndex: 2,
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundColor: CCColors.ChessBoard.Light,
              },
              opacityAnimStyle,
            ]}
          />
          <Image
            style={{
              zIndex: 1,
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
            source={require('@/Assets/Images/Svgs/chessboard.svg')}
          />
        </>
      )}
      {children}
    </View>
  );
};

const defaultFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
let orderStatusTimer;

const orderStatusMapping = {
  pending: {
    title: 'Payment Processing',
    content:
      'Your payment is currently being processed. This may take a few moments.',
    subcontent:
      'Your payment is secure. We use industry-standard encryption to protect your information.',
    time: 'Estimated processing time: 2 minutes',
    feedback:
      "Thank you for choosing us! We're working hard to complete your payment smoothly.",
  },
  failure: {
    title: 'Payment Failed',
    content:
      "We're sorry, but we were unable to process your payment at this time.",
    subcontent:
      'Please review your payment details and try again. If you continue to experience issues, please contact your bank or try a different payment method.',
    feedback:
      'We apologize for any inconvenience caused. Thank you for your understanding.',
  },
  success: {
    title: 'Payment Successful',
    content: 'Congratulations! Your transaction has been completed.',
    subcontent:
      'Your payment is secure. We use industry-standard encryption to protect your information.',
    feedback:
      'Thank you for shopping with us! We look forward to serving you again soon.',
  },
};

const BannerContext = React.createContext<any>(null);

const StableTabWrapper = ({
  originalComponent: Component,
  hideTopBanner,
}: {
  originalComponent: any;
  hideTopBanner: boolean;
}) => {
  const {topBanner, isMobileOrTab} = React.useContext(BannerContext);

  const banner = !hideTopBanner  ? (
    <Box
      style={{
        paddingTop: isMobileOrTab ? 10 : 20,
        paddingHorizontal: isMobileOrTab ? 10 : 20,
      }}>
      <TopBannerRenderer
        activeBanner={topBanner.activeBanner}
        renewalBannerData={topBanner.renewalBannerData}
        isLoading={topBanner.isLoading}
      />
    </Box>
  ) : null;

  return (
    <Box flex={1}>
      <Component banner={banner} />
    </Box>
  );
};

const Books = ({dashboardData, setLatestBookId, setLatestBookName, setUserData}) => {
  const {isMobileOrTab} = useMediaQuery();
  const navigation = useNavigation();
  const linkTo = useLinkTo();
  const userData = dashboardData.user;
  const route = useRoute();
  const tournamentId = route.params?.tournamentId;
  const navigator = useNavigation();
  const selectedBook = route.params?.bookKey;
  const bookName = route.params?.name;
  const courseId = route.params?.course;
  const fromtab = route.params?.fromTab;
  const {mutate: fetchBooks, data} = useBooksApi();
  const {
    mutate: verifyPuzzle,
    data: puzzleData,
    reset: resetPuzzleData,
    isLoading: isVerifyingPuzzle,
  } = useBookPuzzleSolveApi();

  const handleOnSuccessCsocDetails = data => {
    setSubscriptionData(data?.csoc_list || []);
  };
  const handleOnCsocError = data => {};
  const {mutate: getSubscriptionDetails} = useGetSubscriptionDetailsApi(
    handleOnSuccessCsocDetails,
    handleOnCsocError,
  );

  const [orderId, setOrderId] = useState('');
  const [bookResponse, setBookResponse] = useState({});
  const [currentOrderStatus, setCurrentOrderStatus] =
    useState<string>('pending');
  const bookOrderSuccess = async (apiData: any) => {
    if (apiData?.content?.payment_links && orderBookId) {
      await setLocalStorage(
        'book_order',
        JSON.stringify({
          [bookType === 'video_courses' ? 'course_id' : 'book_id']: orderBookId,
          order_id: apiData?.content?.order_id,
        }),
      );
      if (apiData?.content?.payment_links?.web) {
        if (window) {
          window.location.href = apiData?.content?.payment_links?.web;
        } else {
          Linking.openURL(apiData?.content?.payment_links?.web);
        }
      }
    }
  };
  const bookOrderError = apiData => {};
  const {
    mutate: orderBook,
    data: orderData,
    isLoading,
  } = useBookOrderApi(bookOrderSuccess, bookOrderError);

  const bookOrderStatusSuccess = async (apiData: any) => {
    setCurrentOrderStatus(apiData.status);
    if (apiData.status === 'success' || apiData.status === 'failure') {
      if (bookType === 'video_courses') {
        getVideoCourses({});
        // getVideoCourses({page: videoCoursePage, page_size: 15});
      }
      const bookOrder = await getLocalStorage('book_order');
      const data = JSON.parse(bookOrder);
      await removeLocalStorage('book_order');
      clearInterval(orderStatusTimer);
      setTimeout(() => {
        setOrderId('');
      }, 2000);
      if (bookResponse.books && data.book_id) {
        const res = bookResponse;
        const index = res.books.findIndex(x => x.id === data.book_id);
        res.books[index].paid = true;
        res.books[index].bought_by.push(res.user_id);
        console.log(res, 'setBookResponse res');
        setBookResponse(res);
        setBookType('books');
      }
    }
  };

  const bookOrderStatusError = () => {
    clearInterval(orderStatusTimer);
  };

  const {mutate: orderBookStatus, data: orderStatusResponse} =
    useBookOrderStatusApi(bookOrderStatusSuccess, bookOrderStatusError);

  const getVideoCoursesSuccess = data => {
    const responseData = data?.data;
    setBookResponse(prev => ({
      ...prev,
      video_courses: responseData,
    }));
    setVideoCourses(Array.isArray(responseData) ? responseData : []);
    setIsVideoCoursesLoaded(true);
    setVideoCourseLoader(false);
    if (data?.pagination) {
      setVideoCourseTotalPages(data.pagination.total_pages || 1);
    }
  };

  const handleWatchVideo = useCallback(
    (id: number) => {
      navigation.setParams({
        tab: 'video_courses',
        course: id,
      });
    },
    [navigation],
  );

  const getVideoCoursesError = error => {
    setVideoCourseLoader(false);
  };

  const {mutate: getVideoCourses} = useVideoCoursesApi(
    getVideoCoursesSuccess,
    getVideoCoursesError,
  );

  const {mutate: fetchVideoCourseById} = useVideoCourseByIdApi(apiData => {
    setSelectedVideo(apiData?.data);
  });
  const [webinarData, setWebinarData] = useState([]);

  const [userKey, setUserKey] = useState<string>(userData?.user_key);

  const [booksList, setBooksList] = useState([]);
  const [videoCourses, setVideoCourses] = useState([]);
  const [isVideoCoursesLoaded, setIsVideoCoursesLoaded] = useState(false);
  const [videoCoursePage, setVideoCoursePage] = useState(1);
  const [videoCourseTotalPages, setVideoCourseTotalPages] = useState(1);
  const [chapters, setChapters] = useState([]);
  const [bookType, setBookType] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [courseTerm, setCourseTerm] = useState('');

  const [selectedItem, setSelectedItem] = useState<any>({});
  const [selectedVideo, setSelectedVideo] = useState<any>(null);
  const [result, setResult] = useState({text: '', isSuccess: false});
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [showChapters, setShowChapters] = useState<boolean>(false);
  const [videoLoading, setVideoLoading] = useState<boolean>(false);
  const [isChapterHover, setChapterHover] = useState<number>(0);
  const [answer, setAnswer] = useState('');
  const [progress, setProgress] = useState(0);
  const [orderBookId, setOrderBookId] = useState(null);
  const [moveCount, setMoveCount] = useState(0);
  const [opponentMoveFen, setOpponentMoveFen] = useState(null);
  const [isOpponentMovePending, setIsOpponentMovePending] = useState(false);
  const [avatarStatus, setAvatarStatus] = useState<AvatarStatus>('idle');
  const [isEvaluateRedirect, setIsEvaluateRedirect] = useState<Boolean>();
  const [resolvedTournamentId, setResolvedTournamentId] = useState<
    string | number | null
  >(route.params?.tournamentId ?? null);
  const [isEvaluateLoader, setIsEvaluateLoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [showDeletePopup, setDeleteShowPopup] = useState(false);
  const [reloadLoginState, setReloadLoginState] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isPuzzleCompleted, setIsPuzzleCompleted] = useState(false);
  const [progressColors, setProgressColors] = useState<string[]>([]);
  const [videoCourseLoader, setVideoCourseLoader] = useState(true);
  const [booksListLoading, setBooksListLoading] = useState(true);
  const [booksData, setBooksData] = useState<any>(null);
  const [popupBlocked, setPopupBlocked] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState([]);

  const isPersonalCoach = subscriptionData?.some(
    item => item?.tournament_id === 50108,
  );

  // A non-empty csoc_list from subscription/v1/get_csoc_subscription is what
  // makes someone a CSOC student. Gate stays up on every tab until the profile
  // is complete.
  const hasCsocSubscription = (subscriptionData?.length || 0) > 0;
  const csocProfileGate = useCsocProfileNudge({hasCsocSubscription});

  const topBanner = useTopBanner(
    bookType,
    userData?.user_id,
    userData?.mobile_number,
    userData?.is_coach,
  );

  const isOpenAssignment = useMemo(
    () => data?.data?.book?.product_type === 3,
    [data?.data?.book?.product_type],
  );

  const isDisabled = useMemo(() => {
    return (
      (isEvaluateRedirect || (!isEvaluateRedirect && isOpenAssignment)) &&
      (puzzleData?.data?.book_completed ?? isCompleted)
    );
  }, [
    isEvaluateRedirect,
    isOpenAssignment,
    puzzleData?.data?.book_completed,
    isCompleted,
  ]);

  const handleResetPuzzleData = () => {
    resetPuzzleData();
    // verifyPuzzle.reset()
  };
  const calculateProgressColors = () => {
    if (selectedItem?.total_moves) {
      const updatedColors = Array.from(
        {length: selectedItem?.total_moves},
        (_, index) => {
          let backgroundColor = CCColors?.TextColor?.Grey;
          let currentMoveIndex = Math.floor(moveCount / 2);

          if (moveCount === 0 && selectedItem?.total_moves > 1) {
            backgroundColor =
              index === 0
                ? CCColors?.Primary?.Default
                : CCColors?.TextColor?.Grey;
          } else if (
            (index === currentMoveIndex &&
              currentMoveIndex === selectedItem?.total_moves) ||
            puzzleData?.data?.stop
          ) {
            backgroundColor = CCColors?.Green;
          } else {
            if (index < currentMoveIndex) {
              backgroundColor = CCColors?.Green;
            } else if (index === currentMoveIndex) {
              backgroundColor = CCColors?.Primary?.Default;
            }
          }

          return backgroundColor;
        },
      );

      setProgressColors(updatedColors);
    }
  };

  useEffect(() => {
    calculateProgressColors();
  }, [moveCount, selectedItem?.total_moves, puzzleData?.data?.stop]);

  useEffect(() => {
    setIsCompleted(data?.data.book?.completed);
    setIsPuzzleCompleted(selectedItem?.solved);
    // debugger;
  }, [data?.data.book?.completed, selectedItem?.solved]);

  // useEffect(() => {
  //   const unsubscribe = navigation.addListener('focus', () => {
  //     fetchBooks({product_type: productType, book_id: selectedBook});
  //     setOrderId(route.params?.order_id);
  //   });

  //   return unsubscribe;
  // }, [navigation]);

  useEffect(() => {
    if (
      (data?.data?.book?.completed || puzzleData?.data?.book_completed) === true
    ) {
      setIsModalVisible(true);
    }
  }, [data?.data?.book?.completed, puzzleData?.data?.book_completed]);

  useEffect(() => {
    if (
      (isEvaluateRedirect || (!isEvaluateRedirect && isOpenAssignment)) &&
      puzzleData?.data?.valid === 1 &&
      verifyingPuzzleIdRef.current !== null &&
      verifyingPuzzleIdRef.current === selectedItem?.id &&
      (puzzleData?.data?.solved ||
        puzzleData?.data?.stop ||
        puzzleData?.data?.incorrect === 1)
    ) {
      const delay = puzzleData?.data?.incorrect === 1 ? 1000 : 2000;

      const timeout = setTimeout(() => {
        if (selectedItem.chapter_index < chapters.length) {
          onChapterChange(selectedItem.chapter_index + 1);
        }
      }, delay);

      return () => clearTimeout(timeout);
    }
  }, [puzzleData, isEvaluateRedirect, chapters.length, isOpenAssignment]);

  const productType = useMemo(() => {
    setAnswer('');

    if (bookType === 'user_assignment') {
      return 1;
    }
    return 0;
  }, [bookType]);

  const handleRefetch = useCallback(
    (payload: any) => {
      fetchBooks(payload, {
        onSuccess: (response: any) => {
          if (payload?.product_type === 2) {
            const fetchedBooks = response?.data?.books || null;
            setBooksData(fetchedBooks);
          }
        },
      });
    },
    [fetchBooks],
  );

  const importSuccess = (product_type = 0) => {
    fetchBooks({product_type});
    setOpenDrawer(false);
  };

  // useEffect(() => {

  // }, []);

  // useEffect(() => {
  //   if (!selectedBook) {
  //     fetchBooks({product_type: productType, book_id: selectedBook});
  //     setOrderId(route.params?.order_id);
  //   }
  // }, [productType]);

  useEffect(() => {
    if (courseId) {
      setSelectedVideo({id: Number(courseId), loading: true});
      fetchVideoCourseById({courseId: Number(courseId)});
    }
  }, [courseId]);

  const missingTournamentAlertSent = useRef(false);
  const wrongBookAlertSent = useRef(false);
  // Tracks the puzzle id for which the most-recent verifyPuzzle call was made.
  // Cleared on chapter change so that stale in-flight responses are ignored.
  const verifyingPuzzleIdRef = useRef<number | null>(null);
  // Timeout ID for the scheduled opponent-move animation (1.5 s after a correct move).
  // Stored so it can be cancelled when the user navigates to another chapter.
  const opponentMoveTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Synchronous guard: true from the moment a move is submitted until the full
  // cycle (API response + opponent animation) is done. Prevents navigation during
  // the one-render-cycle gap before isVerifyingPuzzle (react-query isLoading) updates.
  const isMovePendingRef = useRef(false);
  // Monotonically-increasing counter; bumped on every chapter change.
  // Async closures compare their captured value against this to detect staleness.
  const puzzleEpochRef = useRef(0);

  useEffect(() => {
    let mounted = true;
    const resolveTournamentId = async () => {
      const fromUrl = (() => {
        try {
          return new URLSearchParams(window?.location?.search).get(
            'tournamentId',
          );
        } catch (e) {
          return null;
        }
      })();
      let fromStorage = await getLocalStorage('tournamentId');
      let isEvaluate = await getLocalStorage('isEvaluate');
      let tid = route.params?.tournamentId || fromUrl || fromStorage;

      if (mounted && tid) {
        setResolvedTournamentId(tid as string | number);
        return;
      }

      // Login's own handleEvaluate effect persists isEvaluate/tournamentId to
      // storage asynchronously and isn't guaranteed to land before this screen
      // mounts (they're two independent effects across a navigation). Re-check
      // once after a short delay before concluding it's genuinely missing, to
      // avoid false-positive alerts from that handoff race.
      if (mounted && isEvaluate && !tid) {
        await new Promise(resolve => setTimeout(resolve, 800));
        if (!mounted) {
          return;
        }
        fromStorage = await getLocalStorage('tournamentId');
        isEvaluate = await getLocalStorage('isEvaluate');
        tid = route.params?.tournamentId || fromUrl || fromStorage;
        if (tid) {
          setResolvedTournamentId(tid as string | number);
          return;
        }
      }

      if (mounted && isEvaluate && !tid && !missingTournamentAlertSent.current) {
        missingTournamentAlertSent.current = true;
        try {
          Sentry.withScope(scope => {
            scope.setTag('feature', 'evaluate_assessment');
            scope.setTag('evaluate_issue', 'missing_tournament_id');
            scope.setUser({
              id: userData?.user_id,
              username: userData?.mobile_number,
            });
            scope.setContext('evaluate', {
              reason: 'missing_tournament_id',
              userPhone: userData?.mobile_number ?? null,
              userId: userData?.user_id ?? null,
              isEvaluate,
              routeParamTournamentId: route.params?.tournamentId ?? null,
              urlTournamentId: fromUrl,
              storedTournamentId: fromStorage ?? null,
              url:
                typeof window !== 'undefined' ? window?.location?.href : null,
              routeParams: route.params ?? null,
            });
            scope.setLevel('error');
            Sentry.captureMessage(
              'Evaluate login: tournamentId missing — assessment cannot be resolved',
            );
          });
        } catch (e) {
          // Sentry not initialised (dev) — ignore.
        }
      }
    };
    resolveTournamentId();
    return () => {
      mounted = false;
    };
  }, [route.params?.tournamentId]);

  useEffect(() => {
    if (data?.data?.books) {
      setBooksList(data.data?.[bookType]);
      console.log(data?.data, 'setBookResponse data?.data');
      setBookResponse(data?.data);
      setBooksListLoading(false);
      // debugger; //never stopped
    }
    if (data?.data?.chapters) {
      const formattedChapters = data.data.chapters?.map((i, index) =>
        i?.current_move
          ? {...i, orientation: 'white', chapter_index: index + 1}
          : {...i, orientation: 'black', chapter_index: index + 1},
      );

      setChapters(formattedChapters);

      let item;
      if (isEvaluateRedirect || (!isEvaluateRedirect && isOpenAssignment)) {
        item = formattedChapters.find(ch => !ch.solved && !ch.attempted);
      }
      if (!item) {
        item = formattedChapters[0];
      }
      // setSelectedChapter(item.id);
      let game;
      try {
        game = new Chess(item.fen);
      } catch (error) {
        game = new Chess(defaultFen);
      }

      item = {
        ...item,
        previousFen: game.fen(),
        currentPosition: game.fen(),
        originalPosition: game.fen(),
        // orientation: game.fen().indexOf(' b ') > 0 ? 'Black' : 'White',
        attempts: 0,
      };
      // setResult({text: `${game.fen()indexOf(' b ') > 0 ? 'Black' : 'White'} to play`, isSuccess: false});
      setResult({
        text: (game.turn() === 'b' ? 'Black' : 'White') + ' to play',
        isSuccess: false,
      });
      setSelectedItem(item);
    }
  }, [data, isEvaluateRedirect, isOpenAssignment]);

  useEffect(() => {
    if (puzzleData?.data?.chapter_list && selectedItem) {
      const updatedChapter = puzzleData.data.chapter_list.find(
        ch => ch.chapter_index === selectedItem.chapter_index,
      );

      if (updatedChapter) {
        setSelectedItem(prev => ({
          ...prev,
          solved: updatedChapter.solved,
        }));
      }
    }
  }, [puzzleData?.data?.chapter_list, selectedItem?.chapter_index]);

  useEffect(() => {
    // if (selectedBook) {
    if (isEvaluateRedirect) {
      if (!resolvedTournamentId) {
        return;
      }
      fetchBooks({product_type: 2, tournament_id: resolvedTournamentId});
      setResult({text: '', isSuccess: false});
    } else {
      fetchBooks({book_id: selectedBook, product_type: productType});
      setResult({text: '', isSuccess: false});
      getSubscriptionDetails();
    }
    // }
  }, [selectedBook, productType, isEvaluateRedirect, resolvedTournamentId]);

  const onSearchBook = debounce(text => {
    let books = bookResponse[bookType];
    if (text?.length) {
      books = books.filter(b =>
        b.book.toLowerCase().includes(text.toLowerCase()),
      );
    }
    setBooksList(books);
  }, 500);

  const onVideoSearch = debounce(text => {
    setCourseTerm(text);
    setVideoCoursePage(1);
    setVideoCourseLoader(true);
    setVideoCourses([]); // Clear old data when new search starts
    getVideoCourses({search: text, page: 1, page_size: 20});
  }, 500);

  const [isVisible, setIsVisible] = useState(true);

  const closeBanner = () => {
    setIsVisible(false);
  };

  const [resultOpacityAnimStyle, startResultOpacityAnim] = useAnimation({
    prop: 'opacity',
    start: 1,
    end: 1,
    repeat: true,
    numberOfReps: 2,
    inputRange: [0, 0.1],
    duration: 1000,
  });

  const [incorrectSound] = useSound(wrongSound);

  function showSolutionFeedback(isSuccess, stop = false) {
    if (isSuccess) {
      setResult({
        text: `Correct! ${
          stop ? 'Solved Puzzle successfully' : 'Please proceed with next move'
        }`,
        isSuccess: true,
      });
      setSelectedItem(prev => ({
        ...prev,
        solved: stop ? true : false,
      }));
    } else {
      incorrectSound();
      setResult({
        text: `Your move is not the best. Try again!${
          !isOpenAssignment &&
          !isEvaluateRedirect &&
          ' The puzzle is still incomplete. Play the best move to finish it.'
        }`,
        isSuccess: false,
      });
    }
    startResultOpacityAnim();
  }

  const onChapterChange = value => {
    if (isMovePendingRef.current) return;
    // setSelectedChapter(value);
    // setResult({text: '', isSuccess: false});
    puzzleEpochRef.current++;
    verifyingPuzzleIdRef.current = null;
    if (opponentMoveTimeoutRef.current !== null) {
      clearTimeout(opponentMoveTimeoutRef.current);
      opponentMoveTimeoutRef.current = null;
    }
    isMovePendingRef.current = false;
    setIsOpponentMovePending(false);
    setAvatarStatus('idle');
    resetPuzzleData();
    setAnswer('');
    setMoveCount(0);
    setIsPuzzleCompleted(selectedItem?.solved);
    setProgressColors(
      Array.from(
        {length: selectedItem?.total_moves || 1},
        () => CCColors?.TextColor?.Grey,
      ),
    );

    let item = chapters.find(i => i.chapter_index === Number(value));
    let game;
    try {
      game = new Chess(item.fen);
    } catch (error) {
      game = new Chess(defaultFen);
    }
    item = {
      ...item,
      previousFen: game.fen(),
      currentPosition: game.fen(),
      originalPosition: game.fen(),
      // orientation: game.fen().indexOf(' b ') > 0 ? 'Black' : 'White',
      attempts: 0,
    };
    setResult({
      text: (game.turn() === 'b' ? 'Black' : 'White') + ' to play',
      isSuccess: false,
    });
    setSelectedItem(item);
  };

  useEffect(() => {
    if (
      ['user_assignment', 'video_courses'].includes(bookType) &&
      Object.keys(bookResponse).length
    ) {
      if (bookType === 'video_courses' && !courseId) {
        if (!bookResponse[bookType]) {
          setVideoCourseLoader(true);
          getVideoCourses({});
        } else {
          setVideoCourses(bookResponse[bookType]);
        }
      } else {
        setBooksList(
          bookResponse?.books?.[
            bookType === 'user_assignment' ? 'private' : bookType
          ] || [],
        );
      }
    }
  }, [bookResponse, bookType, getVideoCourses]);

  const handleOpponentMove = (stop, epoch) => {
    if (puzzleEpochRef.current !== epoch) {
      setIsOpponentMovePending(false);
      return;
    }
    if (stop) {
      setIsOpponentMovePending(false);
      setResult({
        text: 'Solved Puzzle successfully',
        isSuccess: true,
      });
      return;
    }

    let game;
    try {
      game = new Chess(selectedItem.currentPosition);
    } catch (error) {
      game = new Chess(defaultFen);
    }

    const possibleMoves = game.moves();
    if (possibleMoves.length > 0) {
      const opponentMove = puzzleData?.data?.opponent_move;
      let moveResult;
      try {
        moveResult = game.move(opponentMove);
      } catch {
        // opponent_move from API is invalid for current position — skip
      }

      if (moveResult) {
        const newFen = game.fen();
        setOpponentMoveFen(newFen);
        setSelectedItem(prev => ({
          ...prev,
          previousFen: prev.currentPosition,
          currentPosition: newFen,
        }));

        setTimeout(() => {
          if (puzzleEpochRef.current !== epoch) return;
          isMovePendingRef.current = false;
          setIsOpponentMovePending(false);
          setAvatarStatus('idle');
          setResult({
            text: 'Your turn to move!',
            isSuccess: false,
          });
        }, 500);
      } else {
        // If opponent's move is not valid, stop the puzzle
        setIsOpponentMovePending(false);
        setResult({
          text: 'No more moves possible. Puzzle complete!',
          isSuccess: true,
        });
      }
    } else {
      setIsOpponentMovePending(false);
      setResult({
        text: 'No more moves possible. Puzzle complete!',
        isSuccess: true,
      });
    }
  };

  const handlePieceDrop = tempPosition => {
    // debugger;
    setIsCompleted(false);
    setIsPuzzleCompleted(false);

    const move = {
      // from: s,
      // to: d,
      // promotion: p,
    };
    // const game = new Chess(selectedItem.originalPosition);
    // const tempResult = game.move(move);
    isMovePendingRef.current = true;
    verifyingPuzzleIdRef.current = selectedItem.id;
    setAvatarStatus('loading');
    verifyPuzzle({
      position_index: selectedItem.id,
      fen: selectedItem.currentPosition,
      move: tempPosition.san,
      move_count: moveCount,
    });
    setSelectedItem(prev => ({
      ...prev,
      currentPosition: tempPosition?.newFen,
      lastMove: tempPosition?.lastFen,
      attempts: prev.attempts + 1,
    }));

    // setTimeout(() => {
    //   handleOpponentMove(false);
    // }, 1000);
  };

  useEffect(() => {
    return () => {
      setSelectedItem({});
      setResult({text: '', isSuccess: false});
      setAnswer('');
      setMoveCount(0);
    };
  }, [selectedBook]);

  useEffect(() => {
    const data = puzzleData?.data;
    if (data) {
      if (
        verifyingPuzzleIdRef.current === null ||
        verifyingPuzzleIdRef.current !== selectedItem?.id
      ) {
        return;
      }
      showSolutionFeedback(!data?.incorrect, data?.stop);
      if (!data?.incorrect || data?.show_answer) {
        if (data?.answer_text) {
          setAnswer(`${data?.best_move}\n${data?.answer_text}`);
        } else {
          setAnswer(`${data?.best_move}`);
        }

        setMoveCount(data?.move_count);

        if (!data.incorrect && !data.stop) {
          // Correct intermediate move — keep 'loading' while opponent animates
          const epoch = puzzleEpochRef.current;
          setIsOpponentMovePending(true);
          opponentMoveTimeoutRef.current = setTimeout(() => {
            opponentMoveTimeoutRef.current = null;
            handleOpponentMove(puzzleData?.data?.stop, epoch);
          }, 1500);
        } else if (!data.incorrect && data.stop) {
          // Puzzle fully solved — unblock navigation
          isMovePendingRef.current = false;
          setAvatarStatus('correct');
        } else if (data.incorrect && data.show_answer) {
          // Wrong move but solution is being revealed — show incorrect then idle
          isMovePendingRef.current = false;
          setAvatarStatus('incorrect');
          setTimeout(() => setAvatarStatus('idle'), 1400);
        }
      } else {
        // Incorrect move — unblock so user can retry, shake then idle
        isMovePendingRef.current = false;
        setAvatarStatus('incorrect');
        setTimeout(() => setAvatarStatus('idle'), 1400);
        setAnswer('');
      }
      if (data.incorrect) {
        setSelectedItem(prev => {
          const revertedPosition =
            prev.lastMove || prev.previousFen || prev.currentPosition;
          return {
            ...prev,
            currentPosition: revertedPosition,
            originalPosition: revertedPosition,
          };
        });
      } else {
        setSelectedItem(prev => ({
          ...prev,
          originalPosition: prev.currentPosition,
        }));
      }
    }
  }, [puzzleData]);

  const handleOrderBook = data => {
    setOrderBookId(data?.book_id ? data.book_id : data.course_id);
    orderBook(data);
  };

  useEffect(() => {
    const orderStatusCheck = async () => {
      const bookOrder = await getLocalStorage('book_order');
      const payload = JSON.parse(bookOrder);
      if (payload?.order_id) {
        setOrderId(payload.order_id);
        orderStatusTimer = setInterval(() => {
          orderBookStatus(payload);
        }, 1000);
      } else {
        setOrderId('');
      }
    };
    if (route?.params?.order_id) {
      orderStatusCheck();
    }
  }, []);

  useEffect(() => {
    // Simulate payment processing
    let paymentProcessingInterval;
    if (!!orderId && currentOrderStatus === 'pending') {
      paymentProcessingInterval = setInterval(() => {
        setProgress(prevProgress => prevProgress + 1);
        if (progress >= 100) {
          clearInterval(paymentProcessingInterval);
        }
      }, 1000);
    } else {
      clearInterval(paymentProcessingInterval);
    }
    return () => {
      clearInterval(paymentProcessingInterval);
    };
  }, [progress, orderId]);

  const [tabs, setTabs] = useState([
    // {
    //   key: 'private',
    //   label: 'My Books',
    //   component: () => (
    //     <ScrollView
    //       style={{padding: isMobileOrTab ? 0 : 20}}
    //       showsVerticalScrollIndicator={false}>
    //       <Spacer spacing={vs(36)} />
    //       <Box
    //         {...(!isMobileOrTab && {type: 'row-center-between'})}
    //         // type="row-center-between"
    //         style={isMobileOrTab ? {flexDirection: 'column'} : {}}>
    //         <Box
    //           // type="row-flex-start"
    //           {...(!isMobileOrTab && {type: 'row-flex-start'})}
    //           style={isMobileOrTab ? {flexDirection: 'column'} : {}}>
    //           <CCText fontSize={FontSizes[24]} color={CCColors.Primary.Dark}>
    //             My Books
    //           </CCText>
    //           <Spacer spacing={vs(36)} horizontal />
    //           <CCTextInput
    //             icon={search}
    //             fontSize={14}
    //             value={searchTerm}
    //             style={{
    //               width: 300,
    //               height: 40,
    //               backgroundColor: CCColors.White,
    //               overflow: 'hidden',
    //             }}
    //             autoFocus={searchTerm?.length}
    //             placeholder="Search a Book"
    //             onChangeText={text => {
    //               setSearchTerm(text);
    //               onSearchBook(text);
    //             }}
    //             placeholderTextColor={CCColors.TextColor.Grey}
    //           />
    //         </Box>
    //         {isMobileOrTab && <Spacer spacing={10} />}
    //         <Box type={isMobileOrTab ? 'row-center-between' : 'row-flex-start'}>
    //           <CCButton
    //             icon={upload}
    //             titleStyle={{color: CCColors.TextColor.Dark}}
    //             style={{backgroundColor: CCColors.White}}
    //             onPress={() => {
    //               setOpenDrawer(true);
    //             }}>
    //             Upload
    //           </CCButton>
    //           <Spacer spacing={vs(10)} horizontal />
    //           <CCButton
    //             icon={discover}
    //             onPress={() => setBookType('books')}
    //             titleStyle={{color: CCColors.TextColor.Dark}}>
    //             Discover Books
    //           </CCButton>
    //         </Box>
    //       </Box>
    //       <Spacer spacing={vs(36)} />
    //       {booksList?.length ? (
    //         <Box type="row-flex-start" flexWrap="wrap" gap={20}>
    //           {booksList?.map((book, i) => (
    //             <BookCard
    //               {...book}
    //               id={book?.id}
    //               book={book?.name}
    //               paid={!Number(book?.price) ? true : Number(book?.price)}
    //               book_price={book?.price}
    //               book_mrp={book?.mrp}
    //               type="circlechess"
    //               progress={0}
    //             />
    //           ))}
    //         </Box>
    //       ) : (
    //         <Empty
    //           imgSrc={searchTerm?.length ? emptyResult : emptyBook}
    //           title={searchTerm?.length ? 'No results found' : 'No books found'}
    //           description={
    //             searchTerm?.length
    //               ? `We couldn’t find any book matching ”${searchTerm}”
    //           Try again with other book name.`
    //               : 'You can discover and buy from our collection of chess books or upload your own with the .pgn format'
    //           }>
    //           <Box type="row-flex-start">
    //             <CCButton
    //               icon={upload}
    //               titleStyle={{color: CCColors.TextColor.Dark}}
    //               style={{backgroundColor: CCColors.Primary.lightBrown}}
    //               onPress={() => {
    //                 setOpenDrawer(true);
    //               }}>
    //               Upload
    //             </CCButton>
    //             <Spacer spacing={vs(10)} horizontal />
    //             <CCButton
    //               icon={discover}
    //               onPress={() => {
    //                 setBookType('books');
    //               }}
    //               titleStyle={{color: CCColors.TextColor.Dark}}>
    //               Discover Books
    //             </CCButton>
    //           </Box>
    //         </Empty>
    //       )}
    //       <SlideModal
    //         type="side"
    //         width={0.3}
    //         modalHeaderTitle={'Upload Book'}
    //         visible={openDrawer}
    //         onClose={() => {
    //           setOpenDrawer(false);
    //         }}>
    //         <UploadBook
    //           importSuccess={importSuccess}
    //           uploadType={
    //             bookType === 'user_assignment' ? 'assignment' : 'book'
    //           }
    //           buttonName={
    //             bookType === 'user_assignment'
    //               ? 'Upload Assignment'
    //               : 'Upload Book'
    //           }
    //         />
    //       </SlideModal>
    //     </ScrollView>
    //   ),
    // },
    // {
    //   key: 'books',
    //   label: 'Circlechess Store',
    //   component: () => (
    //     <ScrollView style={{padding: 20}}>
    //       <Spacer spacing={vs(36)} />
    //       <Box type={isMobileOrTab ? '' : 'row-center-between'}>
    //         <CCText fontSize={24} color={CCColors.Primary.Dark}>
    //           Circlechess Books
    //         </CCText>
    //         {isMobileOrTab && <Spacer spacing={10} />}
    //         <CCTextInput
    //           icon={search}
    //           fontSize={14}
    //           value={searchTerm}
    //           style={{
    //             width: isMobileOrTab ? 290 : 300,
    //             height: 40,
    //             backgroundColor: CCColors.White,
    //             overflow: 'hidden',
    //           }}
    //           placeholder="Search a Book"
    //           onChangeText={text => {
    //             setSearchTerm(text);
    //             onSearchBook(text);
    //           }}
    //           placeholderTextColor={CCColors.TextColor.Grey}
    //         />
    //       </Box>
    //       <Spacer spacing={vs(36)} />
    //       {booksList?.length ? (
    //         <Box type="row-flex-start" flexWrap="wrap" gap={20}>
    //           {booksList.map((book, i) => (
    //             <BookCard
    //               {...book}
    //               type="circlechess"
    //               userData={userData}
    //               userId={bookResponse['user_id']}
    //               orderBook={handleOrderBook}
    //             />
    //           ))}
    //         </Box>
    //       ) : (
    //         <Empty
    //           imgSrc={searchTerm?.length ? emptyResult : emptyBook}
    //           title={searchTerm?.length ? 'No results found' : 'No books found'}
    //           description={
    //             searchTerm?.length
    //               ? `We couldn’t find any book matching ”${searchTerm}”
    //       Try again with other book name.`
    //               : 'You can discover and buy from our collection of chess books or upload your own with the .pgn format'
    //           }>
    //           <Box type="row-flex-start">
    //             <CCButton
    //               icon={upload}
    //               titleStyle={{color: CCColors.TextColor.Dark}}
    //               style={{backgroundColor: CCColors.Primary.lightBrown}}
    //               onPress={() => {
    //                 setOpenDrawer(true);
    //               }}>
    //               Upload
    //             </CCButton>
    //             <Spacer spacing={vs(10)} horizontal />
    //             <CCButton
    //               icon={discover}
    //               onPress={() => {
    //                 setBookType('books');
    //               }}
    //               titleStyle={{color: CCColors.TextColor.Dark}}>
    //               Discover Books
    //             </CCButton>
    //           </Box>
    //         </Empty>
    //       )}
    //     </ScrollView>
    //   ),
    // },
    {
      key: 'meeting',
      // Display label only — the 'meeting' key backs the ?tab=meeting URL and
      // must not change (existing links and deep links depend on it).
      label: 'Schedule',
      component: ({banner}: {banner?: React.ReactNode}) => (
        <Meetings
          userKey={userData.user_key}
          userContact={userData?.mobile_number}
          userData={userData}
          setUserData={setUserData}
          setPopupBlocked={setPopupBlocked}
          banner={banner}
        />
      ),
    },
    {
      key: 'mentor_calls',
      label: 'Mentor Calls',
      component: ({banner}: {banner?: React.ReactNode}) => (
        <MentorCalls
          userId={userData.user_id}
          isMentor={userData.is_mentor || false}
          mobile={userData.mobile_number}
          userKey={userData.user_key}
          user_timezone={userData?.user_timezone?.selected}
          setPopupBlocked={setPopupBlocked}
          isPersonalCoach={isPersonalCoach}
          banner={banner}
        />
      ),
    },
    {
      key: 'subscription',
      label: 'Subscription',
      component: ({banner}: {banner?: React.ReactNode}) => (
        <SubscriptionTab
          userContact={userData?.mobile_number}
          userId={userData.user_id}
          userKey={userData?.user_key}
          banner={banner}
        />
      ),
    },
    {
      key: 'ccLeague',
      label: 'CircleChess Leagues',
      component: ({banner}: {banner?: React.ReactNode}) => (
        <CCLeague userData={userData} banner={banner} />
      ),
    },
    {
      key: 'user_assignment',
      label: 'My Assignments',
      component: ({banner}: {banner?: React.ReactNode}) => (
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={{height: '80vh'}}>
          <Assignment
            search={search}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearch={onSearchBook}
            booksList={booksList}
            booksListLoading={booksListLoading}
            emptyResult={emptyResult}
            emptyBook={emptyBook}
            upload={upload}
            setBookType={setBookType}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            importSuccess={importSuccess}
            userData={userData}
            userId={bookResponse.user_id}
            orderBook={handleOrderBook}
            banner={banner}
            // refetch={handleRefetch}
            // inFocus={bookType === 'user_assignment'}
          />
        </ScrollView>
      ),
    },
    {
      key: 'video_courses',
      label: 'Video Courses',
      component: ({banner}: {banner?: React.ReactNode}) =>
        VideoCourses({
          courseTerm,
          setCourseTerm,
          onVideoSearch,
          videoCourses,
          userData,
          handleOrderBook,
          videoCourseLoader,
          bookType,
          onWatchVideo: handleWatchVideo,
          currentPage: videoCoursePage,
          totalPages: videoCourseTotalPages,
          banner,
          onPageChange: (page: number) => {
            setVideoCoursePage(page);
            setVideoCourseLoader(true);
            getVideoCourses({page, page_size: 20, search: courseTerm});
          },
        }),
    },
  ]);

  // const tabs = useMemo(
  //   () => ,
  //   [
  //     search,
  //     searchTerm,
  //     setSearchTerm,
  //     onSearchBook,
  //     booksList,
  //     emptyResult,
  //     emptyBook,
  //     upload,
  //     setBookType,
  //     openDrawer,
  //     setOpenDrawer,
  //     importSuccess,
  //     userData,
  //     handleOrderBook,
  //     videoCourses,
  //   ],
  // );

  useEffect(() => {
    setTabs(prevTabs =>
      prevTabs.map(tab =>
        tab.key === 'mentor_calls'
          ? {
              ...tab,
              label: isPersonalCoach ? 'Personal Consultant' : 'Mentor Calls',
              component: ({banner}: {banner?: React.ReactNode}) => (
                <MentorCalls
                  userId={userData.user_id}
                  isMentor={userData.is_mentor || false}
                  mobile={userData.mobile_number}
                  userKey={userData.user_key}
                  user_timezone={userData?.user_timezone?.selected}
                  setPopupBlocked={setPopupBlocked}
                  isPersonalCoach={isPersonalCoach}
                  banner={banner}
                />
              ),
            }
          : tab,
      ),
    );
  }, [isPersonalCoach]);

  useEffect(() => {
    const updatedTabs = [...tabs];
    const index = updatedTabs.findIndex(t => t.key === bookType);
    if (
      bookType === 'video_courses' &&
      (videoCourses.length > 0 || courseTerm.length > 0)
    ) {
      updatedTabs[index] = {
        key: 'video_courses',
        label: 'Video Courses',
        component: ({banner}: {banner?: React.ReactNode}) =>
          VideoCourses({
            courseTerm,
            setCourseTerm,
            onVideoSearch,
            videoCourses,
            userData,
            handleOrderBook,
            videoCourseLoader,
            bookType,
            onWatchVideo: handleWatchVideo,
            currentPage: videoCoursePage,
            totalPages: videoCourseTotalPages,
            banner,
            onPageChange: (page: number) => {
              setVideoCoursePage(page);
              setVideoCourseLoader(true);
              getVideoCourses({page, page_size: 20, search: courseTerm});
            },
          }),
      };
      setTabs(updatedTabs);
    }
    if (bookType === 'user_assignment') {
      updatedTabs[index] = {
        key: 'user_assignment',
        label: 'My Assignments',
        component: ({banner}: {banner?: React.ReactNode}) => (
          <ScrollView
            showsVerticalScrollIndicator={true}
            style={{height: '80vh'}}>
            <Assignment
              search={search}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onSearch={onSearchBook}
              booksList={booksList}
              booksListLoading={booksListLoading}
              emptyResult={emptyResult}
              emptyBook={emptyBook}
              upload={upload}
              setBookType={setBookType}
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
              importSuccess={importSuccess}
              userData={userData}
              userId={bookResponse.user_id}
              orderBook={handleOrderBook}
              banner={banner}
              // refetch={handleRefetch}
              // inFocus={bookType === 'user_assignment'}
            />
          </ScrollView>
        ),
      };
      setTabs(updatedTabs);
    }
  }, [
    searchTerm,
    booksList,
    userData,
    videoCourses,
    bookType,
    courseTerm,
    openDrawer,
    // videoCoursePage,
    // videoCourseTotalPages,
  ]);

  const tabItems = useMemo(() => {
    return tabs
      .filter(t => !t?.isHidden)
      .map(t => ({
        ...t,
        component: () => (
          <StableTabWrapper
            originalComponent={t.component}
            hideTopBanner={t.hideTopBanner}
          />
        ),
      }));
  }, [tabs]);

  const updateUrl = useCallback(params => {
    navigation.setParams(params);
  }, []);

  useEffect(() => {
    const settingBookType = async () => {
      const routeParams = navigation
        .getState()
        .routes.find(r => r.name === ScreenName?.Books)?.params;
      // const route = useRoute(); // Get the route object
      const routeParamsMobile = route?.params; // Access route parameters
      const urlParams = new URLSearchParams(window.location.search);
      const tabFromUrl = urlParams.get('tab');
      const isEvaluate = await getLocalStorage('isEvaluate');
      console.log(
        'parameters',
        routeParams,
        'mobileparameters',
        routeParamsMobile,
        'urlParams',
        tabFromUrl,
      );

      if (
        isEvaluateRedirect &&
        bookType === 'user_assignment' &&
        resolvedTournamentId &&
        booksData &&
        Object.values(booksData).every(
          (arr: any) => Array.isArray(arr) && arr.length === 0,
        )
      ) {
        setIsEvaluateLoader(false);
        await handleLogout?.();
        onLoginStateChange?.();
        return;
      }

      if (isEvaluate) {
        setIsEvaluateRedirect(true);
        const book = data?.data?.book;
        if (!book) {
          return;
        }
        const id = book?.id;
        const name = book?.name?.replace(/\s+/g, '-');

        const expectedTid = resolvedTournamentId;
        const servedTid = book?.tournament_id;
        if (
          expectedTid &&
          servedTid != null &&
          String(servedTid) !== String(expectedTid) &&
          !wrongBookAlertSent.current
        ) {
          wrongBookAlertSent.current = true;
          try {
            Sentry.withScope(scope => {
              scope.setTag('feature', 'evaluate_assessment');
              scope.setTag('evaluate_issue', 'wrong_assessment_opened');
              scope.setUser({
                id: userData?.user_id,
                username: userData?.mobile_number,
              });
              scope.setContext('evaluate', {
                reason: 'wrong_assessment_opened',
                userPhone: userData?.mobile_number ?? null,
                userId: userData?.user_id ?? null,
                expectedTournamentId: expectedTid,
                servedBookId: id,
                servedBookName: book?.name,
                servedBookTournamentId: servedTid,
                url:
                  typeof window !== 'undefined'
                    ? window?.location?.href
                    : null,
              });
              scope.setLevel('error');
              Sentry.captureMessage(
                'Evaluate login: wrong assessment opened — book tournament_id mismatch',
              );
            });
          } catch (e) {
            // Sentry not initialised (dev) — ignore.
          }
        }

        setLatestBookId?.(id);
        setLatestBookName?.(name);
        updateUrl({tab: 'user_assignment', name, bookKey: id});
      }

      if (tabFromUrl && tabs.some(t => t.key === tabFromUrl)) {
        setBookType(tabFromUrl);
      } else if (
        routeParams &&
        routeParams.tab &&
        tabs.some(t => t.key === routeParams.tab)
      ) {
        setBookType(routeParams.tab);
        updateUrl(routeParams.tab);
      } else if (!isEvaluate) {
        setBookType('meeting');
        updateUrl({tab: 'meeting'});
      }
      setIsEvaluateLoader(false);
    };
    if (data?.data) {
      settingBookType();
    }
  }, [data, isEvaluateRedirect]);
  useEffect(() => {
    if (route?.params?.tab) {
      setBookType(route?.params?.tab);
    }
  }, [route?.params?.tab]);

  const handleTabChange = ({route}) => {
    setCourseTerm('');
    setSearchTerm('');
    setBookType(route.key);
    updateUrl({tab: route.key});
    if (route.key === 'meeting' || route.key === 'mentor_calls') {
      const isPopupOpened = openPopup();
      if (isPopupOpened === false) {
        setPopupBlocked(!isPopupOpened);
      }
    }
  };

  useEffect(() => {
    if (isEvaluateRedirect && bookType === 'user_assignment') {
      if (!resolvedTournamentId) {
        return;
      }
      handleRefetch?.({product_type: 2, tournament_id: resolvedTournamentId});
    } else if (bookType === 'user_assignment') {
      handleRefetch?.({product_type: 1, book_id: selectedBook});
    }
  }, [bookType, isEvaluateRedirect, resolvedTournamentId]);

  const handleBackPress = () => {
    // navigation.navigate(ScreenName?.Books, {tab: bookType});
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);
    console.log('handle back pressed');
    navigation.reset({
      index: 0, // Reset to the first screen in the stack
      routes: [
        {
          name: ScreenName?.Books,
          params: {tab: 'video_courses'},
        },
      ],
    });
  };

  const {
    data: loginData,
    loading,
    isUserLoggedIn,
    error,
  } = useLoginState(reloadLoginState);

  function handleOnCancel() {
    setShowPopup(false);
    setDeleteShowPopup(false);
  }

  function onLoginStateChange() {
    setReloadLoginState(prev => !prev);
    window.location.href = '';
  }

  if (isEvaluateLoader) {
    return <Loader loading bgWhite />;
  }

  const totalChapters = data?.data?.chapters?.length;
  const solvedCount =
    data?.data?.chapters?.filter(chapter => chapter.solved)?.length || 0;
  const attemptedChapters =
    data?.data?.chapters?.filter(
      chapter => chapter.attempted === true && chapter.solved === false,
    )?.length || 0;
  const totalScoredCount =
    data?.data?.chapters?.filter(chapter => chapter.scored === true)?.length ||
    0;

  const totalMoves = selectedItem?.total_moves || 0;
  const currentMoveIndex = Math.floor(moveCount / 2);
  const isIncorrect = puzzleData?.data?.incorrect === 1;
  const isSolved = puzzleData?.data?.solved === true;
  const isStopped = puzzleData?.data?.stop === true;
  const moveNumber = isIncorrect
    ? currentMoveIndex + 1
    : Math.min(currentMoveIndex, totalMoves);

  const assignmentView = () => {
    return (
      <View
        style={{
          flex: !isMobileOrTab ? 0.6 : '',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <ScrollView style={{flex: 1}} showsVerticalScrollIndicator={false}>
          <Box
            type="row-center-between"
            style={{padding: isMobileOrTab ? 14 : 30}}>
            <Box
              type="row-flex-start"
              style={{alignItems: 'center', gap: 20, width: '85%'}}>
              <View>
                {isMobileOrTab && (
                  <Box
                    style={{marginBottom: 5}}
                    onPress={() => {
                      handleResetPuzzleData?.();
                      navigation.navigate(ScreenName.Books, {tab: bookType});
                    }}>
                    <Ionicons
                      name={'arrow-back'}
                      size={25}
                      color={CCColors.Primary.Brown}
                    />
                  </Box>
                )}
                <View
                  style={{
                    backgroundColor: CCColors?.White,
                    borderWidth: 1,
                    borderColor: CCColors?.Primary?.Brown,
                    borderRadius: 8,
                    padding: 6,
                    width: 110,
                    alignItems: 'center',
                  }}>
                  {data?.data?.book?.week && (
                    <View
                      style={{
                        backgroundColor: CCColors?.Primary?.Brown,
                        borderRadius: 4,
                        width: '100%',
                        paddingVertical: 6,
                        alignItems: 'center',
                      }}>
                      <CCText
                        fontSize={14}
                        fontWeight="500"
                        color={CCColors?.White}>
                        {data?.data?.book?.week}
                      </CCText>{' '}
                    </View>
                  )}
                  <View
                    style={{
                      paddingVertical: 6,
                    }}>
                    <CCText
                      fontSize={12}
                      fontWeight="600"
                      color={CCColors?.Primary?.Brown}>
                      {formatDateToDDMMYYYY(data?.data?.book?.create_timestamp)}
                    </CCText>{' '}
                  </View>
                </View>
              </View>
              <View style={{flex: 1}}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                  }}>
                  <CCText
                    fontSize={16}
                    color={CCColors?.TextColor?.Grey}
                    style={{flexShrink: 0}}>
                    Class -{' '}
                  </CCText>
                  <CCText
                    fontSize={16}
                    style={{
                      textTransform: 'capitalize',
                      flexShrink: 1,
                      maxWidth: '100%',
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail">
                    {bookName}
                  </CCText>
                </View>
                <Spacer spacing={vs(5)} />
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                  }}>
                  <CCText
                    fontSize={14}
                    color={CCColors?.TextColor?.Grey}
                    style={{flexShrink: 0}}>
                    Chapter {selectedItem.chapter_index} -{' '}
                  </CCText>
                  <CCText
                    fontSize={14}
                    style={{
                      flexShrink: 1,
                      maxWidth: isMobileOrTab ? '70%' : 'auto',
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail">
                    {selectedItem.chapter}
                  </CCText>
                </View>
                <Spacer spacing={4} />
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    width: '100%',
                  }}>
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      width: '50%',
                    }}>
                    <ProgressBar
                      style={{
                        flex: 1,
                        height: 6,
                        backgroundColor: 'rgba(38, 35, 34, 0.1)',
                        borderRadius: 3,
                        marginRight: 10,
                      }}
                      progress={
                        (selectedItem.chapter_index || 1) / chapters?.length
                      }
                      fillStyle={{backgroundColor: '#3DAB9E'}}
                      text={undefined}
                      icon={undefined}
                    />
                    <Spacer spacing={vs(5)} />
                    <CCText
                      fontSize={12}
                      style={{
                        marginLeft: 8,
                        color: '#262322',
                        flexShrink: 0, // Ensures text does not overflow
                      }}>
                      {selectedItem?.chapter_index || 1}/{chapters?.length}
                    </CCText>
                  </View>
                  {isMobileOrTab && !isEvaluateRedirect && (
                    <Box
                      type="row-flex-start"
                      onPress={() => setShowChapters(true)}
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: '40%',
                        marginLeft: 10,
                      }}>
                      <img
                        src={chapterIcon}
                        style={{width: 16, height: 16}}
                        alt="chapter icon"
                      />
                      <Spacer spacing={vs(6)} horizontal />
                      <CCText
                        fontSize={14}
                        color={CCColors.Green}
                        style={{
                          marginRight: 5,
                          lineHeight: 20,
                          fontWeight: '500',
                        }}>
                        Change
                      </CCText>
                    </Box>
                  )}
                </View>
              </View>
            </Box>
            {showPopup && (
              <SlideModal
                visible={showPopup}
                type="center"
                customStyle={styles.levelModalCustom}>
                <PopUp
                  confirm={async () => {
                    await handleLogout();
                    onLoginStateChange();
                  }}
                  cancel={handleOnCancel}
                  text={'Are you sure you want to logout?'}
                  buttonConfirm="Logout"
                />
              </SlideModal>
            )}
            {!isMobileOrTab && isEvaluateRedirect && selectedBook && (
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}>
                <Box
                  type="row-flex-end"
                  style={{
                    backgroundColor: updateColorWithOpacity(
                      CCColors?.Primary?.Brown,
                      0.8,
                    ),
                    borderRadius: 8,
                    padding: 8,
                    margin: 8,
                  }}
                  onPress={() => setShowPopup(true)}>
                  <CCText fontSize={FontSizes[15]} color={CCColors.White}>
                    Logout
                  </CCText>
                  <Ionicons
                    name={'arrow-forward'}
                    size={25}
                    color={CCColors.White}
                  />
                </Box>
              </View>
            )}
          </Box>
          <Divider />
          <View
            style={{
              paddingHorizontal: isMobileOrTab ? 16 : 40,
              paddingVertical: isMobileOrTab ? 15 : 40,
            }}>
            <View>
              {isCompleted ||
              (isOpenAssignment && puzzleData?.data?.book_completed) ? (
                // Show Congratulations section if the book is completed
                <View
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                  }}>
                  <View style={{width: '100%', alignItems: 'center'}}>
                    <Image
                      resizeMode="contain"
                      style={{
                        width: isMobileOrTab ? 136 : '100%',
                        height: isMobileOrTab ? 132 : 200,
                      }}
                      source={congrats}
                      alt="Congratulations!"
                    />
                  </View>
                  <CCText
                    style={{
                      fontSize: 20,
                      fontWeight: 'bold',
                      marginTop: isMobileOrTab ? 10 : 20,
                    }}>
                    Congratulations!
                  </CCText>
                  <CCText
                    style={{
                      fontSize: isMobileOrTab ? 14 : 16,
                      textAlign: 'center',
                      marginTop: 10,
                    }}>
                    You have successfully completed the {bookName}.
                  </CCText>
                </View>
              ) : (
                <>
                  <View style={[styles.progressIndicatorContainer, {justifyContent: 'space-between', marginBottom: 0}]}>
                    <View style={{flexDirection: 'row', alignItems: 'center'}}>
                      <CCText style={{marginRight: 10}}>Puzzle</CCText>
                      {progressColors.map((backgroundColor, index) => (
                        <View
                          key={index}
                          style={[styles.progressDot, {backgroundColor}]}
                        />
                      ))}
                    </View>
                    <PuzzleAvatar
                      status={avatarStatus}
                      size={isMobileOrTab ? 70 : 110}
                      labelPosition="right"
                    />
                  </View>
                  {selectedItem?.comments && (
                    <CCText style={filterStyles.containerHeading}>
                      {selectedItem.comments}
                    </CCText>
                  )}
                  {answer && (
                    <>
                      <Spacer spacing={vs(isMobileOrTab ? 10 : 20)} />
                      <Box style={styles.whiteBox}>
                        <CCText style={filterStyles.containerHeading}>
                          Solution
                        </CCText>
                        <Spacer spacing={vs(10)} />
                        <CCText
                          style={{
                            lineHeight: 22,
                            fontSize: isMobileOrTab ? 12 : 16,
                            marginBottom: 5,
                          }}>
                          {answer}
                        </CCText>
                      </Box>
                      {puzzleData?.data?.stop && puzzleData?.data?.solved ? (
                        <Box
                          style={{
                            backgroundColor: updateColorWithOpacity(
                              CCColors?.Primary?.Brown,
                              0.08,
                            ),
                            borderLeftWidth: 4,
                            borderLeftColor: CCColors?.Primary?.Brown,
                            padding: 18,
                            borderRadius: 10,
                          }}>
                          {puzzleData?.data?.league_points_awarded === true ? (
                            <>
                              <CCText
                                style={{
                                  fontSize: isMobileOrTab ? 14 : 15,
                                  lineHeight: 22,
                                }}>
                                🏆 You’ve earned{' '}
                                <CCText style={{fontWeight: '700'}}>
                                  {puzzleData?.data?.league_points}
                                </CCText>{' '}
                                league points, credited on{' '}
                                <CCText style={{fontWeight: '600'}}>
                                  {formatDateToDDMMYYYY(
                                    puzzleData?.data?.league_points_date,
                                  )}
                                </CCText>
                                .
                              </CCText>
                              <Spacer spacing={10} />
                              <CCText
                                style={{
                                  fontSize: 14,
                                  color: CCColors?.TextColor?.GreyText,
                                }}>
                                View detailed accrual information in the{' '}
                                <CCText style={{fontWeight: '600'}}>
                                  Points Summary
                                </CCText>{' '}
                                tab under{' '}
                                <CCText
                                  onPress={() =>
                                    navigation.navigate(ScreenName?.Books, {
                                      tab: 'ccLeague',
                                    })
                                  }
                                  style={{
                                    color: CCColors.BlueAqua,
                                    textDecorationLine: 'underline',
                                    fontWeight: '600',
                                  }}>
                                  CircleChess Leagues
                                </CCText>
                                .
                              </CCText>
                            </>
                          ) : puzzleData?.data?.league_points_awarded ===
                            false ? (
                            <CCText
                              style={{
                                fontSize: 14,
                                lineHeight: 22,
                              }}>
                              You successfully solved all {totalMoves} moves.
                              However, league points were not awarded because
                              the maximum point limit was reached for the week
                              ending{' '}
                              <CCText style={{fontWeight: '600'}}>
                                {formatDateToDDMMYYYY(
                                  puzzleData?.data?.league_points_date,
                                )}
                              </CCText>
                              .
                            </CCText>
                          ) : (
                            <CCText
                              style={{
                                fontSize: 14,
                                lineHeight: 22,
                              }}>
                              You solved all {totalMoves} moves successfully.
                            </CCText>
                          )}
                        </Box>
                      ) : (
                        <Box
                          style={{
                            backgroundColor: updateColorWithOpacity(
                              CCColors?.Primary?.Brown,
                              0.08,
                            ),
                            borderLeftWidth: 4,
                            borderLeftColor: CCColors?.Primary?.Brown,
                            padding: 18,
                            borderRadius: 10,
                          }}>
                          <CCText
                            style={{
                              fontSize: isMobileOrTab ? 14 : 15,
                              color: CCColors?.Primary?.Brown,
                              lineHeight: 22,
                            }}>
                            {isIncorrect ? (
                              <>
                                ❌ After multiple incorrect attempts, here is
                                the solution for{' '}
                                <CCText style={{fontWeight: '600'}}>
                                  Puzzle {selectedItem?.chapter_index}
                                </CCText>{' '}
                                — Move {moveNumber} of {totalMoves}.{'\n'}
                                Study this move carefully before proceeding.
                              </>
                            ) : (
                              <>
                                This is the solution for{' '}
                                <CCText style={{fontWeight: '600'}}>
                                  Puzzle {selectedItem?.chapter_index}
                                </CCText>{' '}
                                — Move {moveNumber} of {totalMoves}.{'\n'}
                                Continue playing the remaining moves to complete
                                the puzzle.
                              </>
                            )}
                          </CCText>
                        </Box>
                      )}
                    </>
                  )}
                  <Divider
                    marginTop={isMobileOrTab ? 5 : 40}
                    marginBottom={isMobileOrTab ? 10 : 40}
                  />
                  {/* Navigation Buttons */}
                  {/* {!isEvaluateRedirect && !isOpenAssignment && (
                    <Box type="row-center-between">
                      <View style={{width: 150}}>
                        {selectedItem.chapter_index > 1 && (
                          <>
                            <CCButton
                              isRounded={false}
                              type="none"
                              titleStyle={{textAlign: 'center'}}
                              style={{
                                backgroundColor: CCColors.White,
                                borderRadius: 8,
                                width: 100,
                                border: `1px solid ${CCColors.Border}`,
                                padding: 10,
                              }}
                              onPress={() =>
                                onChapterChange(selectedItem.chapter_index - 1)
                              }
                              disabled={selectedItem.chapter_index === 1}>
                              Previous
                            </CCButton>
                            <Spacer spacing={vs(20)} />
                            <CCText numberOfLines={2}>
                              {
                                chapters.find(
                                  c =>
                                    c?.chapter_index ===
                                    selectedItem?.chapter_index - 1,
                                )?.sub_chapter
                              }
                            </CCText>
                          </>
                        )}
                      </View>
                      <View style={{width: 150}}>
                        {selectedItem.chapter_index < chapters.length && (
                          <>
                            <CCButton
                              isRounded={false}
                              type="none"
                              titleStyle={{textAlign: 'center'}}
                              onPress={() =>
                                onChapterChange(selectedItem.chapter_index + 1)
                              }
                              style={{
                                backgroundColor:
                                  selectedItem?.solved === true
                                    ? CCColors?.Green
                                    : CCColors.White,
                                borderRadius: 8,
                                width: 90,
                                alignSelf: 'flex-end',
                                border: `1px solid ${CCColors.Border}`,
                                padding: 10,
                              }}>
                              <CCText
                                style={{
                                  textAlign: 'center',
                                  color:
                                    selectedItem?.solved === true
                                      ? CCColors?.White
                                      : '',
                                }}>
                                Next
                              </CCText>
                            </CCButton>
                            <Spacer spacing={vs(20)} />
                            <CCText
                              numberOfLines={2}
                              style={{textAlign: 'right'}}>
                              {
                                chapters.find(
                                  c =>
                                    c?.chapter_index ===
                                    selectedItem?.chapter_index + 1,
                                )?.sub_chapter
                              }
                            </CCText>
                          </>
                        )}
                      </View>
                    </Box>
                  )} */}
                </>
              )}
              {/* Puzzle Completed Message */}
              {!isEvaluateRedirect && !isCompleted && isPuzzleCompleted && (
                <View
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                  }}>
                  <View style={{width: '100%', alignItems: 'center'}}>
                    <Image
                      resizeMode="contain"
                      style={{
                        width: isMobileOrTab ? 136 : '100%',
                        height: isMobileOrTab ? 132 : 200,
                      }}
                      source={congrats}
                      alt="Puzzle Completed!"
                    />
                  </View>
                  <CCText
                    style={{
                      fontSize: 20,
                      fontWeight: '500',
                      marginTop: isMobileOrTab ? 10 : 20,
                    }}>
                    Puzzle Completed!
                  </CCText>
                  <CCText
                    style={{
                      fontSize: isMobileOrTab ? 14 : 16,
                      textAlign: 'center',
                      marginTop: 10,
                    }}>
                    You have successfully completed the puzzle of{' '}
                    {selectedItem.chapter}.
                  </CCText>
                </View>
              )}
              {isEvaluateRedirect && (
                <View
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                  }}>
                  {puzzleData?.data?.incorrect === 0 &&
                    !isCompleted &&
                    isPuzzleCompleted && (
                      <View style={{width: '100%', alignItems: 'center'}}>
                        <Image
                          resizeMode="contain"
                          style={{
                            width: isMobileOrTab ? 136 : '100%',
                            height: isMobileOrTab ? 132 : 200,
                          }}
                          source={congrats}
                          alt="Puzzle Completed!"
                        />
                      </View>
                    )}
                  <CCText
                    style={{
                      fontSize: 20,
                      fontWeight: '500',
                      marginTop: isMobileOrTab ? 10 : 20,
                      backgroundColor:
                        puzzleData?.data?.incorrect === 1
                          ? CCColors?.White
                          : 'transparent',
                      padding: puzzleData?.data?.incorrect === 1 ? 10 : 0,
                      borderRadius: puzzleData?.data?.incorrect === 1 ? 8 : 0,
                      borderWidth: puzzleData?.data?.incorrect === 1 ? 1 : 0,
                      borderColor:
                        puzzleData?.data?.incorrect === 1
                          ? CCColors?.Border
                          : 'transparent',
                    }}>
                    {puzzleData?.data?.incorrect === 0 &&
                    !isCompleted &&
                    isPuzzleCompleted
                      ? 'Puzzle Completed!'
                      : puzzleData?.data?.incorrect === 1 &&
                        '❌ Incorrect Move, Moving To Next Puzzle...'}
                  </CCText>
                  {puzzleData?.data?.incorrect === 0 &&
                    !isCompleted &&
                    isPuzzleCompleted && (
                      <CCText
                        style={{
                          fontSize: isMobileOrTab ? 14 : 16,
                          textAlign: 'center',
                          marginTop: 10,
                        }}>
                        You have successfully completed the puzzle of{' '}
                        {selectedItem.chapter}.
                      </CCText>
                    )}
                </View>
              )}
            </View>
          </View>
        </ScrollView>
        {/* Navigation Buttons */}
        {!isEvaluateRedirect && !isOpenAssignment && (
          <Box type="row-center">
            {/* Previous Button */}
            <View style={{width: 150}}>
              {selectedItem.chapter_index > 1 && (
                <>
                  <CCButton
                    isRounded={false}
                    type="none"
                    titleStyle={{textAlign: 'center'}}
                    style={{
                      backgroundColor: CCColors.White,
                      borderRadius: 8,
                      width: 100,
                      borderWidth: 1,
                      borderColor: CCColors.Border,
                      padding: 10,
                    }}
                    onPress={() =>
                      onChapterChange(selectedItem.chapter_index - 1)
                    }
                    disabled={selectedItem.chapter_index === 1 || isVerifyingPuzzle || isOpponentMovePending}>
                    Previous
                  </CCButton>
                  <Spacer spacing={vs(20)} />
                  <CCText numberOfLines={2}>
                    {
                      chapters.find(
                        c =>
                          c?.chapter_index === selectedItem?.chapter_index - 1,
                      )?.sub_chapter
                    }
                  </CCText>
                </>
              )}
            </View>
            <View style={{width: 150}}>
              {selectedItem.chapter_index < chapters.length && (
                <>
                  <CCButton
                    isRounded={false}
                    type="none"
                    titleStyle={{textAlign: 'center'}}
                    onPress={() =>
                      onChapterChange(selectedItem.chapter_index + 1)
                    }
                    disabled={isVerifyingPuzzle || isOpponentMovePending}
                    style={{
                      backgroundColor:
                        selectedItem?.solved === true
                          ? CCColors?.Green
                          : CCColors.White,
                      borderRadius: 8,
                      width: 90,
                      alignSelf: 'flex-end',
                      borderWidth: 1,
                      borderColor: CCColors.Border,
                      padding: 10,
                    }}>
                    <CCText
                      style={{
                        textAlign: 'center',
                        color:
                          selectedItem?.solved === true ? CCColors?.White : '',
                      }}>
                      Next
                    </CCText>
                  </CCButton>
                  <Spacer spacing={vs(20)} />
                  <CCText numberOfLines={2} style={{textAlign: 'right'}}>
                    {
                      chapters.find(
                        c =>
                          c?.chapter_index === selectedItem?.chapter_index + 1,
                      )?.sub_chapter
                    }
                  </CCText>
                </>
              )}
            </View>
          </Box>
        )}
      </View>
    );
  };

  const assignmentTabs = [
    {
      key: 'assignment',
      label: 'Assignment',
      component: assignmentView,
    },
    {
      key: 'leaderboard',
      label: 'Leaderboard',
      component: () => (
        <Leaderboard bookId={selectedBook} puzzleData={puzzleData?.data} />
      ),
    },
  ];

  return (
    <View
      style={{
        backgroundColor: '#FAF6EB',
        padding: selectedBook ? 0 : isMobileOrTab ? 5 : 20,
        flex: 1,
      }}>
      {/* {isLoading && <Loader loading />} */}
      {selectedVideo && (
        <Box
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}>
          <Box
            type="row-flex-start"
            style={{
              backgroundColor: updateColorWithOpacity(
                CCColors?.Primary?.Brown,
                0.8,
              ),
              borderRadius: 8,
              padding: 8,
              margin: 8,
            }}
            onPress={handleBackPress}>
            <Ionicons name={'arrow-back'} size={30} color={CCColors.White} />
            <CCText fontSize={FontSizes[18]} color={CCColors.White}>
              Back
            </CCText>
          </Box>
          <CCText fontSize={FontSizes[18]}>
            Pause on a Position to analyse it
          </CCText>
        </Box>
      )}
      {selectedVideo ? (
        <Box flexDirection={isMobileOrTab ? 'column' : 'row'} flex={1}>
          <Box style={{flex: isMobileOrTab ? 1 : 0.7}}>
            <Loader loading={videoLoading} />
            <VideoPlayerWeb
              selectedVideo={selectedVideo}
              onLoad={() => setVideoLoading(false)}
            />
            {/* <Video
              // ref={video}
              style={{width: '100%', height: '50%', flex: 1}}
              videoStyle={{width: '100%'}}
              posterStyle={{width: '100%'}}
              source={{
                uri: selectedVideo.s3_path,
              }}
              onLoad={() => setVideoLoading(false)}
              usePoster={videoLoading}
              posterSource={{
                uri: selectedVideo.thumbnail,
              }}
              useNativeControls
              resizeMode={ResizeMode.CONTAIN}
              // isLooping
              // onPlaybackStatusUpdate={status => setStatus(() => status)}
            /> */}
          </Box>
          <ScrollView
            style={{
              flex: isMobileOrTab ? 1 : 0.5,
              maxHeight: isMobileOrTab ? 400 : 'auto',
            }}>
            <Box type="row-center-between" style={{padding: 20}}>
              <Box type="row-flex-start">
                <Image
                  source={bookIcon}
                  style={styles.bookIcon}
                  alt="Book Icon"
                />
                <View>
                  <CCText fontSize={20} style={{textTransform: 'capitalize'}}>
                    {selectedVideo.title}
                  </CCText>
                </View>
              </Box>
              {/* <Box type="row-flex-start" onPress={() => setShowChapters(true)}>
               <CCText fontSize={16} color={CCColors.Green}>
                 Change Chapter
               </CCText>
               <Spacer spacing={vs(12)} horizontal />
               <img src={chapterIcon} style={{width: 20}} alt="chapter icon" />
             </Box> */}
            </Box>
            <Divider />
            {selectedVideo.content && (
              <Box style={{padding: isMobileOrTab ? 16 : 30}}>
                {selectedVideo.content.topic && (
                  <Box>
                    <CCText fontSize={20} style={{textTransform: 'capitalize'}}>
                      Topics
                    </CCText>
                    <Spacer spacing={vs(20)} />
                    {selectedVideo.content.topic.map(topic => (
                      <Box type="row-flex-start" style={{marginVertical: 5}}>
                        <AntDesign
                          name="checkcircle"
                          size={20}
                          color={CCColors.Primary.Grey}
                          style={{marginRight: 20}}
                        />
                        <CCText
                          fontSize={16}
                          style={{textTransform: 'capitalize'}}>
                          {topic}
                        </CCText>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
            {selectedVideo?.content?.description && (
              <Box>
                <Divider />
                <Box style={{padding: isMobileOrTab ? 16 : 30}}>
                  <CCText fontSize={20} style={{textTransform: 'capitalize'}}>
                    Description
                  </CCText>
                  <Spacer spacing={vs(20)} />
                  {selectedVideo.content?.description?.heading && (
                    <CCText fontSize={16}>
                      {selectedVideo.content?.description?.heading}
                    </CCText>
                  )}
                  {selectedVideo.content?.description?.content.map(c => (
                    <Box style={{marginVertical: 5}}>
                      {/* <AntDesign
                            name="checkcircle"
                            size={20}
                            color={CCColors.Primary.Dark}
                            style={{marginRight: 20}}
                          /> */}
                      <CCText
                        fontSize={16}
                        style={{textTransform: 'capitalize'}}>
                        {c.id}. {c.title}:
                      </CCText>
                      <CCText fontSize={14}>{c.summary}</CCText>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </ScrollView>
        </Box>
      ) : selectedBook && selectedItem ? (
        <Box flexDirection={isMobileOrTab ? 'column' : 'row'} flex={1}>
          {!isMobileOrTab && !isEvaluateRedirect && (
            <Box style={{display: 'flex'}}>
              <TaskList
                bookType={bookType}
                selectedBook={selectedBook}
                isEvaluateRedirect={isEvaluateRedirect}
                totalChapters={totalChapters}
                chapters={chapters}
                selectedItem={selectedItem}
                chapterIndex={data?.data?.book?.chapters}
                solvedChapters={solvedCount}
                attemptedChapters={attemptedChapters}
                onChapterChange={onChapterChange}
                isVerifyingPuzzle={isVerifyingPuzzle || isOpponentMovePending}
                setShowChapters={setShowChapters}
                isChapterHover={isChapterHover}
                setChapterHover={setChapterHover}
                puzzleData={puzzleData?.data}
                totalScoredCount={totalScoredCount}
                handleResetPuzzleData={handleResetPuzzleData}
                dashboardData={dashboardData}
                bookData={data?.data?.book}
                bookId={selectedBook}
                fromTab={fromtab}
              />
              <Leaderboard
                bookId={selectedBook}
                puzzleData={puzzleData?.data}
              />
            </Box>
          )}

          <Box
            style={
              isMobileOrTab
                ? styles.chessboardContainer
                : isEvaluateRedirect && !isMobileOrTab
                ? styles.chessboardContainerWebBooksForEvaluate
                : styles.chessboardContainerWebBooks
            }>
            <ChessBoardLoader isLoading={isLoading || !selectedItem.id}>
              <ChessboardWithArrow
                position={selectedItem.currentPosition}
                // onPieceDropExtension={handlePieceDrop}
                handleNewFen={handlePieceDrop}
                lastMoveFen={selectedItem.previousFen}
                boardOrientation={selectedItem.orientation}
                disabled={isDisabled}
              />
            </ChessBoardLoader>
            {isVisible && (
              <Animated.View
                style={[
                  resultOpacityAnimStyle,
                  {
                    backgroundColor: result.isSuccess
                      ? CCColors.Green
                      : CCColors.Red,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 10,
                  },
                ]}>
                <Icon
                  name={result.isSuccess ? 'check-circle' : 'alert-circle'}
                  size={20}
                  color={CCColors.White}
                />
                <CCText
                  textAlign="left"
                  style={[
                    styles.puzzleSolutionText,
                    {
                      color: CCColors.White,
                      flex: 1,
                      marginHorizontal: 10,
                    },
                  ]}>
                  {result.text}
                </CCText>
                {result.isSuccess && (
                  <TouchableOpacity onPress={closeBanner}>
                    <Icon
                      name="close-circle"
                      size={20}
                      color={CCColors.White}
                    />
                  </TouchableOpacity>
                )}
              </Animated.View>
            )}
            {isEvaluateRedirect && (
              <SlideModal
                modalHeaderTitle="Overall Assessment Summary"
                visible={isModalVisible}
                type="center">
                <View style={styles.modalContainer}>
                  <CCText fontSize={20} style={filterStyles.containerHeading}>
                    Accuracy:{' '}
                    {(
                      ((puzzleData?.data?.summary?.correct ??
                        data?.data?.summary?.correct) /
                        (puzzleData?.data?.summary?.total ??
                          data?.data?.summary?.total)) *
                      100
                    )?.toFixed(2)}
                    %
                  </CCText>
                  <Spacer spacing={vs(20)} />
                  <CCText fontSize={20} style={filterStyles.containerHeading}>
                    Incorrect:{' '}
                    {(puzzleData?.data?.summary?.attempted ??
                      data?.data?.summary?.attempted) -
                      (puzzleData?.data?.summary?.correct ??
                        data?.data?.summary?.correct)}
                  </CCText>
                  <Spacer spacing={vs(20)} />
                  <CCText fontSize={20} style={filterStyles.containerHeading}>
                    {puzzleData?.data?.summary?.result_text ??
                      data?.data?.summary?.result_text}
                  </CCText>
                  <Spacer spacing={vs(20)} />
                  <CCText
                    fontSize={16}
                    color={CCColors.Blue}
                    style={{alignSelf: 'center'}}
                    onPress={async () => {
                      await handleLogout();
                      onLoginStateChange();
                    }}>
                    Back to Home
                    <Ionicons
                      name={'arrow-forward'}
                      size={16}
                      color={CCColors.Blue}
                    />
                  </CCText>
                </View>
              </SlideModal>
            )}
          </Box>
          {!isMobileOrTab ? (
            assignmentView()
          ) : (
            <CCTabs
              tabIndex={0}
              tabStyle={{
                backgroundColor: CCColors?.White,
                width: '100%',
              }}
              tabItems={assignmentTabs}
            />
          )}
          <SlideModal
            type="bottom"
            width={0.3}
            modalHeaderTitle={'Chapters List'}
            visible={showChapters}
            onClose={() => {
              setShowChapters(false);
            }}>
            <ChapterList
              chapters={chapters}
              onChapterChange={onChapterChange}
              isVerifyingPuzzle={isVerifyingPuzzle || isOpponentMovePending}
              setShowChapters={setShowChapters}
              selectedItem={selectedItem}
              isChapterHover={isChapterHover}
              setChapterHover={setChapterHover}
            />
          </SlideModal>
        </Box>
      ) : (
        <Box flex={1}>
          <BannerContext.Provider value={{topBanner, isMobileOrTab}}>
            <CCTabs
              key={bookType}
              tabIndex={tabs.findIndex(t => t.key === bookType)}
              tabItems={tabItems}
              handleTabChange={handleTabChange}
            />
          </BannerContext.Provider>
        </Box>
      )}
      {!!orderId && (
        <SlideModal
          type="center"
          width={0.3}
          modalHeaderTitle={
            <CCText fontSize={24}>
              {orderStatusResponse?.status === 'pending'
                ? 'Payment Pending'
                : orderStatusMapping[currentOrderStatus].title}
            </CCText>
          }
          visible={!!orderId}>
          <View style={{margin: 24}}>
            <CCText fontSize={16}>
              {orderStatusMapping[currentOrderStatus].content}
            </CCText>
            {currentOrderStatus === 'pending' && (
              <>
                <ProgressBar
                  style={{height: 6, backgroundColor: 'rgba(38, 35, 34, 0.1)'}}
                  progress={progress / 100}
                  fillStyle={{backgroundColor: '#3DAB9E'}}
                  text={undefined}
                  icon={undefined}
                />
                <Spacer spacing={vs(15)} />
                <CCText fontSize={14} color={CCColors.TextColor.Grey}>
                  {orderStatusMapping[currentOrderStatus].time}
                </CCText>
              </>
            )}
            {currentOrderStatus === 'failure' &&
              orderStatusResponse?.data?.error_message && (
                <CCText textAlign="center" fontSize={18} color={CCColors.Error}>
                  Reason: {orderStatusResponse?.data?.error_message}
                </CCText>
              )}
            <Spacer spacing={vs(10)} />
            <CCText fontSize={16}>
              {orderStatusMapping[currentOrderStatus].subcontent}
            </CCText>
            <Spacer spacing={vs(30)} />
            <CCText fontSize={16}>
              {orderStatusMapping[currentOrderStatus].feedback}
            </CCText>
            {orderStatusResponse?.status &&
              orderStatusResponse?.status !== 'success' && (
                <Box flexDirection="row" justifyContent="center">
                  <CCButton
                    onPress={() => {
                      setOrderId('');
                      removeLocalStorage('book_order');
                    }}>
                    {orderStatusResponse?.status === 'pending'
                      ? 'Close'
                      : 'Try Again'}
                  </CCButton>
                </Box>
              )}
          </View>
        </SlideModal>
      )}
      <SlideModal
        type="center"
        visible={popupBlocked}
        minWidth={0.3}
        onClose={() => setPopupBlocked(false)}
        modalHeaderTitle="Enable Pop-ups">
        <View>
          <CCText fontSize={16} width={400}>
            Pop-ups are currently blocked in your browser.{'\n'}
            This may prevent your <b>classroom</b> from opening properly.
            {'\n\n'}
            Please enable pop-ups for a smooth experience:
            {'\n'}- Click the{' '}
            <Icon
              name="information-outline"
              size={16}
              color={CCColors?.TextColor?.Primary}
            />{' '}
            info icon in the address bar{'\n'}- Select “Site settings”{'\n'}-
            Find “Pop-ups and redirects”{'\n'}- Choose “Allow”
            {'\n\n'}
            After enabling, please try joining the classroom.
          </CCText>
          <Spacer spacing={20} />
          <CCButton onPress={() => setPopupBlocked(false)}>Okay</CCButton>
        </View>
      </SlideModal>
      {/* Last child so it paints over the tabs and their content. It's absolute
          within THIS view, so the drawer rail and the header stay clickable —
          the user can always leave School of Chess. */}
      {csocProfileGate && <CsocProfileGate />}
    </View>
  );
};

const VideoCourses: React.FC<any> = ({
  courseTerm,
  setCourseTerm,
  onVideoSearch,
  videoCourses,
  userData,
  handleOrderBook,
  videoCourseLoader,
  bookType,
  currentPage,
  totalPages,
  onPageChange,
  onWatchVideo,
  banner,
}) => {
  const {isMobileOrTab} = useMediaQuery();
  const [openVideoUploadDrawer, setOpenVideoUploadDrawer] = useState(false);
  const [importSuccess, setImportSuccess] = useState(null);
  const [message, setMessage] = useState('');

  const uploadType = 'video';

  const handleImportSuccess = (status: boolean) => {
    setImportSuccess(status);
  };

  useEffect(() => {
    if (!openVideoUploadDrawer && importSuccess !== null) {
      setOpenVideoUploadDrawer(false);
      const messageText = importSuccess
        ? 'Video uploaded successfully!'
        : 'Video upload failed.';
      setMessage(messageText);

      const timer = setTimeout(() => {
        setMessage('');
        setImportSuccess(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [openVideoUploadDrawer, importSuccess]);

  return (
    // <View style={{flex: 1, height: '100%'}}>
    <ScrollView style={{padding: 20, flex: 1}}>
      {banner}
      {/* <Spacer spacing={vs(16)} /> */}
      <Box type={isMobileOrTab ? 'column-flex-between' : 'row-center-between'}>
        <CCText fontSize={24} color={CCColors.Primary.Dark}>
          Video Courses
        </CCText>
        {isMobileOrTab && <Spacer spacing={10} />}
        <CCTextInput
          key="video_courses"
          icon={search}
          fontSize={14}
          value={courseTerm}
          autoFocus={courseTerm.length}
          style={{
            width: isMobileOrTab ? 290 : 300,
            height: 40,
            backgroundColor: CCColors.White,
            overflow: 'hidden',
          }}
          placeholder="Search a course by name or tags"
          onChangeText={text => {
            setCourseTerm(text);
            onVideoSearch(text);
          }}
          placeholderTextColor={CCColors.TextColor.Grey}
        />
        {userData.is_staff && (
          <Box type={isMobileOrTab ? 'row-center-between' : 'row-flex-start'}>
            <CCButton
              icon={upload}
              titleStyle={{color: CCColors.TextColor.Dark}}
              style={{backgroundColor: CCColors.White}}
              onPress={() => {
                setOpenVideoUploadDrawer(true);
              }}>
              Upload Video
            </CCButton>
          </Box>
        )}
      </Box>
      <Spacer spacing={vs(20)} />

      {message && (
        <View
          style={{
            position: 'fixed',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: importSuccess
              ? CCColors.Payment.Success
              : CCColors.Error,
            padding: 16,
            borderRadius: 8,
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}>
          <CCText fontSize={16} color={CCColors.White}>
            {message}
          </CCText>
        </View>
      )}

      {videoCourseLoader ? (
        <Loader loading={true} bgStyle={{backgroundColor: 'transparent'}} />
      ) : videoCourses.length ? (
        <Box>
          {videoCourses.map((video, i) => (
            <Box style={{marginVertical: 20}}>
              <CCText fontSize={18} color={CCColors.Primary.Dark}>
                {video.category}
              </CCText>
              <Spacer spacing={vs(10)} />
              <Box
                type="row-flex-start"
                flexWrap="wrap"
                gap={isMobileOrTab ? 10 : 20}>
                {video?.courses?.map(course => (
                  <VideoCard
                    {...course}
                    userData={userData}
                    orderBook={handleOrderBook}
                    bookType={bookType}
                    onWatchVideo={onWatchVideo}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Empty
          imgSrc={courseTerm?.length ? emptyResult : emptyBook}
          title={
            courseTerm?.length ? 'No results found' : 'No video courses found'
          }
          description={
            courseTerm?.length
              ? `We couldn't find any courses matching "${courseTerm}" Try again with other course name or tag.`
              : 'You can discover books'
          }>
          {courseTerm?.length ? (
            <CCButton
              onPress={() => {
                setCourseTerm('');
                onVideoSearch('');
              }}>
              <CCText color={CCColors.White}>Clear Search</CCText>
            </CCButton>
          ) : null}
        </Empty>
      )}
      <SlideModal
        type="side"
        width={0.3}
        modalHeaderTitle={'Upload Video Course'}
        visible={openVideoUploadDrawer}
        onClose={() => setOpenVideoUploadDrawer(false)}>
        <UploadVideo
          buttonName={'Upload Video Course'}
          uploadType={uploadType}
          importSuccess={importSuccess}
          setImportSuccess={handleImportSuccess}
          onClose={() => setOpenVideoUploadDrawer(false)}
          isMobileOrTab={isMobileOrTab}
        />
      </SlideModal>
      {totalPages > 1 && !videoCourseLoader && (
        <View
          style={{
            position: 'sticky',
            bottom: -20,
            borderTopWidth: 1,
            borderTopColor: CCColors.Grey.Border,
            paddingTop: 10,
            paddingBottom: 10,
            alignItems: 'center',
            zIndex: 10,
            backgroundColor: CCColors.Background,
          }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            paginate={onPageChange}
            maxPage={10}
            activeColor
          />
        </View>
      )}
    </ScrollView>
  );
};

export default Books;
